import { createUseParams } from 'utils/createUseParams';
import { flattenRoutes } from '@provider-portal/common/utils/flattenRoutes';

/**
 * TODO If you ever change this route, please update `marketing` section in `moduleRoutes` of
 * `app/src/rdx/analytics/applicationRoutes.ts` accordingly
 */

export const routes = flattenRoutes({
  index: '/smart-promotions/regular',
  addPromotion: 'add',
  details: {
    index: 'details/:promotionId',
    useParams: createUseParams<{ promotionId?: string }>(),
  },
});
